import helpers from './helpers'
import ls from 'local-storage'
import EventEmitter from 'events'

class Token extends EventEmitter {
  init ({axios}) {
    this.axios = axios

    this.handleRefreshTokenCredits()
  }

  handleRefreshTokenCredits () {
    let self = this

    this.refreshCredit = 2
    setInterval(() => {
      if(self.refreshCredit < 2) {
        self.refreshCredit++
      }
    }, 10000)
  }

  getPreferences () {
    let self = this

    return new Promise(function (resolve, reject) {
      self.axios.get(helpers.url('api', '/account/token/preferences'))
        .then(result => {
          resolve(result.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  retrieve (email, password) {
    let self = this

    console.log('[ NEXUS ] Try to authenticate ' + email + ' ...')

    return new Promise(function (resolve, reject) {
      self.axios.post(helpers.url('api', '/account/token/generate'), {email, password})
        .then(result => {
          self.set(result.data.token)
          resolve(result.data.token)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  refresh () {
    let self = this

    this.refreshCredit--
    if (this.refreshCredit < 0) {
      return Promise.reject("Could not refresh token, too much tries.")
    }

    console.log('[ NEXUS ] Try to refresh token ' + this.get() + ' ...')

    return new Promise(function (resolve, reject) {
      self.axios.post(helpers.url('api', '/account/token/regenerate'), {token: self.get()})
        .then(result => {
          self.set(result.data.token)
          resolve(result.data.token)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  isset () {
    return ls.get('token')
  }

  get () {
    return ls.get('token')
  }

  set (token) {
    ls.set('token', token)
    this.emit('changed', {token})

    console.log('[ NEXUS ] Updated new token : ' + this.get() + '.')
  }

  forget () {
    ls.remove('token')
    this.emit('changed', {token: null})

    console.log('[ NEXUS ] Token forgotten.')
  }
}

export let token = new Token()



// WEBPACK FOOTER //
// ./libs/@db2b/nexus-js/token.js